import clsx from 'clsx';

import styles from './Card.module.css';

import type { ReactNode } from 'react';

export interface CardProps {
  readonly children: ReactNode;
  readonly className?: string;
  /** Removes the trailing margin when the card sits inside a grid. */
  readonly flush?: boolean;
}

export function Card({ children, className, flush }: CardProps) {
  return (
    <section className={clsx(styles.card, flush && styles.flush, className)}>{children}</section>
  );
}

export interface CardHeaderProps {
  readonly title: ReactNode;
  readonly actions?: ReactNode;
}

export function CardHeader({ title, actions }: CardHeaderProps) {
  return (
    <header className={styles.header}>
      <span className={styles.title}>{title}</span>
      {actions && <div className={styles.actions}>{actions}</div>}
    </header>
  );
}

export interface CardBodyProps {
  readonly children: ReactNode;
  readonly className?: string;
  /** Use when the body hosts a table that supplies its own padding. */
  readonly flush?: boolean;
}

export function CardBody({ children, className, flush }: CardBodyProps) {
  return <div className={clsx(styles.body, flush && styles.bodyFlush, className)}>{children}</div>;
}
